"use strict";

exports.__esModule = true;
var _MetricValueAggregateElement = require("./MetricValueAggregateElement");
Object.keys(_MetricValueAggregateElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricValueAggregateElement[key]) return;
  exports[key] = _MetricValueAggregateElement[key];
});
var _MetricValueAggregateFields = require("./MetricValueAggregateFields");
Object.keys(_MetricValueAggregateFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricValueAggregateFields[key]) return;
  exports[key] = _MetricValueAggregateFields[key];
});
var _MetricValueAggregateThumbnail = require("./MetricValueAggregateThumbnail");
Object.keys(_MetricValueAggregateThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricValueAggregateThumbnail[key]) return;
  exports[key] = _MetricValueAggregateThumbnail[key];
});
var _MetricValueAggregateHeader = require("./MetricValueAggregateHeader");
Object.keys(_MetricValueAggregateHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricValueAggregateHeader[key]) return;
  exports[key] = _MetricValueAggregateHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});